import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
export const getModalsState = createSelector(getState, (state) => state.modals);
export const getIsOpenModalWindow = createSelector(getModalsState, (state) => Boolean(state.type));
export const getModalData = createSelector(getModalsState, (modalState) => modalState?.data);
